import axios from "axios";
import { SERVER_PATH } from "../../config/env";
import { errorToaster, successToaster } from "./../../utils/index";

// google auth client id
// export const clienId =
//   "541441021566-lmeq5iub6vvrd78bgnjbmr8gershnu0p.apps.googleusercontent.com";

// sivamfarms
export const clienId =
  "65263119192-itch9gpjb9ie1i0o72qs8um7tlkjliu4.apps.googleusercontent.com";

// google auth success
export const onSuccess = async (data) => {
  const code = await axios
    .post(`${SERVER_PATH}post/user.php`, {
      user_id: data.email,
      user_name: data.name,
      address: "",
      mobile_no: "",
      avatar: data.picture,
      pincode: "",
      status: "1",
      state: "",
      no_purchases: "0",
      total_costof_purchases: "0",
    })
    .then((res) => {
      return res.status;
    });
  successToaster({ msg: "Login Successful" });
  return code;
};

// google auth failure
export const onFailure = (res) => {
  errorToaster({ msg: "Somthing went wrong" });
};

// google auth logout
export const onLogoutSuccess = () => {
  successToaster({ msg: "Logout Successful" });
};
